export const panelInformation = [
  {
    brand: "AE Solar",
    panelType: [
      {
        name: "AE530MD-144",
        width: 1.158,
        height: 2.278,
        weight: 27,
        voc: 49.65,
        isc: 13.47,
        pMax: 530,
        tkVoc: -0.275,
        tkIsc: 0.045,
        tkPmax: -0.35,
        efficiency: 20.53,
        tSTC: 25,
        panelSheet1: "../images/panels/AE-Solar/530-550-1.jpg",
        panelSheet2: "../images/panels/AE-Solar/530-550-2.jpg",
      },
      {
        name: "AE535MD-144",
        width: 1.158,
        height: 2.278,
        weight: 27,
        voc: 49.78,
        isc: 13.52,
        pMax: 535,
        tkVoc: -0.275,
        tkIsc: 0.045,
        tkPmax: -0.35,
        efficiency: 20.73,
        tSTC: 25,
        panelSheet1: "../images/panels/AE-Solar/530-550-1.jpg",
        panelSheet2: "../images/panels/AE-Solar/530-550-2.jpg",
      },
      {
        name: "AE540MD-144",
        width: 1.158,
        height: 2.278,
        weight: 27,
        voc: 49.9,
        isc: 13.57,
        pMax: 540,
        tkVoc: -0.275,
        tkIsc: 0.045,
        tkPmax: -0.35,
        efficiency: 20.92,
        tSTC: 25,
        panelSheet1: "../images/panels/AE-Solar/530-550-1.jpg",
        panelSheet2: "../images/panels/AE-Solar/530-550-2.jpg",
      },
      {
        name: "AE545MD-144",
        width: 1.158,
        height: 2.278,
        weight: 27,
        voc: 50.01,
        isc: 13.62,
        pMax: 530,
        tkVoc: -0.275,
        tkIsc: 0.045,
        tkPmax: -0.35,
        efficiency: 21.12,
        tSTC: 25,
        panelSheet1: "../images/panels/AE-Solar/530-550-1.jpg",
        panelSheet2: "../images/panels/AE-Solar/530-550-2.jpg",
      },
      {
        name: "AE550MD-144",
        width: 1.158,
        height: 2.278,
        weight: 27,
        voc: 51.44,
        isc: 13.67,
        pMax: 550,
        tkVoc: -0.275,
        tkIsc: 0.045,
        tkPmax: -0.35,
        efficiency: 21.31,
        tSTC: 25,
        panelSheet1: "../images/panels/AE-Solar/530-550-1.jpg",
        panelSheet2: "../images/panels/AE-Solar/530-550-2.jpg",
      },
      {
        name: "AE560CMD-144BDS",
        width: 1.133,
        height: 2.278,
        weight: 31,
        voc: 50.23,
        isc: 14.14,
        pMax: 560,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 21.7,
        tSTC: 25,
        panelSheet1: "../images/panels/AE-Solar/560-580-1.jpg",
        panelSheet2: "../images/panels/AE-Solar/560-580-2.jpg",
      },
      {
        name: "AE565CMD-144BDS",
        width: 1.133,
        height: 2.278,
        weight: 31,
        voc: 50.39,
        isc: 14.2,
        pMax: 565,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 21.89,
        tSTC: 25,
        panelSheet1: "../images/panels/AE-Solar/560-580-1.jpg",
        panelSheet2: "../images/panels/AE-Solar/560-580-2.jpg",
      },
      {
        name: "AE570CMD-144BDS",
        width: 1.133,
        height: 2.278,
        weight: 31,
        voc: 50.55,
        isc: 14.26,
        pMax: 570,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22.08,
        tSTC: 25,
        panelSheet1: "../images/panels/AE-Solar/560-580-1.jpg",
        panelSheet2: "../images/panels/AE-Solar/560-580-2.jpg",
      },
      {
        name: "AE575CMD-144BDS",
        width: 1.133,
        height: 2.278,
        weight: 31,
        voc: 50.68,
        isc: 14.33,
        pMax: 575,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22.28,
        tSTC: 25,
        panelSheet1: "../images/panels/AE-Solar/560-580-1.jpg",
        panelSheet2: "../images/panels/AE-Solar/560-580-2.jpg",
      },
      {
        name: "AE580CMD-144BDS",
        width: 1.133,
        height: 2.278,
        weight: 31,
        voc: 50.86,
        isc: 14.4,
        pMax: 580,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22.47,
        tSTC: 25,
        panelSheet1: "../images/panels/AE-Solar/560-580-1.jpg",
        panelSheet2: "../images/panels/AE-Solar/560-580-2.jpg",
      },
    ],
  },

  {
    brand: "Akcome",
    panelType: [
      {
        name: "SK9612M(HV)C 545",
        width: 1.159,
        height: 2.278,
        weight: 28.6,
        voc: 49.7,
        isc: 13.84,
        efficiency: 21.1,
        pMax: 545,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        tSTC: 25,
        panelSheet1: "../images/panels/Akcome/545-565-1.jpg",
        panelSheet2: "../images/panels/Akcome/545-565-2.jpg",
      },
      {
        name: "SK9612M(HV)C 550",
        width: 1.159,
        height: 2.278,
        weight: 28.6,
        voc: 49.8,
        isc: 13.94,
        efficiency: 21.3,
        pMax: 550,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        tSTC: 25,
        panelSheet1: "../images/panels/Akcome/545-565-1.jpg",
        panelSheet2: "../images/panels/Akcome/545-565-2.jpg",
      },
      {
        name: "SK9612M(HV)C 555",
        width: 1.159,
        height: 2.278,
        weight: 28.6,
        voc: 49.9,
        isc: 14.04,
        efficiency: 21.49,
        pMax: 555,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        tSTC: 25,
        panelSheet1: "../images/panels/Akcome/545-565-1.jpg",
        panelSheet2: "../images/panels/Akcome/545-565-2.jpg",
      },
      {
        name: "SK9612M(HV)C 560",
        width: 1.159,
        height: 2.278,
        weight: 28.6,
        voc: 50,
        isc: 14.14,
        efficiency: 21.68,
        pMax: 560,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        tSTC: 25,
        panelSheet1: "../images/panels/Akcome/545-565-1.jpg",
        panelSheet2: "../images/panels/Akcome/545-565-2.jpg",
      },
      {
        name: "SK9612M(HV)C 565",
        width: 1.159,
        height: 2.278,
        weight: 28.6,
        voc: 50.1,
        isc: 14.24,
        efficiency: 21.87,
        pMax: 565,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        tSTC: 25,
        panelSheet1: "../images/panels/Akcome/545-565-1.jpg",
        panelSheet2: "../images/panels/Akcome/545-565-2.jpg",
      },
      {
        name: "SK9612TDGDC 560",
        width: 1.159,
        height: 2.278,
        weight: 32.5,
        voc: 50.67,
        isc: 14.13,
        efficiency: 21.68,
        pMax: 560,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        tSTC: 30,
        panelSheet1: "../images/panels/Akcome/560-580-1.jpg",
        panelSheet2: "../images/panels/Akcome/560-580-2.jpg",
      },
      {
        name: "SK9612TDGDC 565",
        width: 1.159,
        height: 2.278,
        weight: 32.5,
        voc: 50.87,
        isc: 14.19,
        efficiency: 21.88,
        pMax: 565,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        tSTC: 30,
        panelSheet1: "../images/panels/Akcome/560-580-1.jpg",
        panelSheet2: "../images/panels/Akcome/560-580-2.jpg",
      },
      {
        name: "SK9612TDGDC 570",
        width: 1.159,
        height: 2.278,
        weight: 32.5,
        voc: 51.07,
        isc: 14.25,
        efficiency: 22.07,
        pMax: 570,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        tSTC: 30,
        panelSheet1: "../images/panels/Akcome/560-580-1.jpg",
        panelSheet2: "../images/panels/Akcome/560-580-2.jpg",
      },
      {
        name: "SK9612TDGDC 575",
        width: 1.159,
        height: 2.278,
        weight: 32.5,
        voc: 51.27,
        isc: 14.31,
        efficiency: 22.26,
        pMax: 575,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        tSTC: 30,
        panelSheet1: "../images/panels/Akcome/560-580-1.jpg",
        panelSheet2: "../images/panels/Akcome/560-580-2.jpg",
      },
      {
        name: "SK9612TDGDC 580",
        width: 1.159,
        height: 2.278,
        weight: 32.5,
        voc: 51.47,
        isc: 14.37,
        efficiency: 22.46,
        pMax: 580,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        tSTC: 30,
        panelSheet1: "../images/panels/Akcome/560-580-1.jpg",
        panelSheet2: "../images/panels/Akcome/560-580-2.jpg",
      },
      {
        name: "SKA611HDGDC 680",
        width: 1.328,
        height: 2.384,
        weight: 38.3,
        voc: 49.15,
        isc: 17.4,
        efficiency: 21.89,
        pMax: 680,
        tkVoc: -0.22,
        tkIsc: 0.047,
        tkPmax: -0.24,
        tSTC: 35,
        panelSheet1: "../images/panels/Akcome/680-700-1.jpg",
        panelSheet2: "../images/panels/Akcome/680-700-2.jpg",
      },
      {
        name: "SKA611HDGDC 685",
        width: 1.328,
        height: 2.384,
        weight: 38.3,
        voc: 49.19,
        isc: 17.45,
        efficiency: 22.05,
        pMax: 685,
        tkVoc: -0.22,
        tkIsc: 0.047,
        tkPmax: -0.24,
        tSTC: 35,
        panelSheet1: "../images/panels/Akcome/680-700-1.jpg",
        panelSheet2: "../images/panels/Akcome/680-700-2.jpg",
      },
      {
        name: "SKA611HDGDC 690",
        width: 1.328,
        height: 2.384,
        weight: 38.3,
        voc: 49.23,
        isc: 17.52,
        efficiency: 22.21,
        pMax: 690,
        tkVoc: -0.22,
        tkIsc: 0.047,
        tkPmax: -0.24,
        tSTC: 35,
        panelSheet1: "../images/panels/Akcome/680-700-1.jpg",
        panelSheet2: "../images/panels/Akcome/680-700-2.jpg",
      },
      {
        name: "SKA611HDGDC 695",
        width: 1.328,
        height: 2.384,
        weight: 38.3,
        voc: 49.27,
        isc: 17.63,
        efficiency: 22.37,
        pMax: 695,
        tkVoc: -0.22,
        tkIsc: 0.047,
        tkPmax: -0.24,
        tSTC: 35,
        panelSheet1: "../images/panels/Akcome/680-700-1.jpg",
        panelSheet2: "../images/panels/Akcome/680-700-2.jpg",
      },
      {
        name: "SKA611HDGDC 700",
        width: 1.328,
        height: 2.384,
        weight: 38.3,
        voc: 49.31,
        isc: 17.72,
        efficiency: 22.53,
        pMax: 700,
        tkVoc: -0.22,
        tkIsc: 0.047,
        tkPmax: -0.24,
        tSTC: 35,
        panelSheet1: "../images/panels/Akcome/680-700-1.jpg",
        panelSheet2: "../images/panels/Akcome/680-700-2.jpg",
      },
    ],
  },

  {
    brand: "Canadian",
    panelType: [
      {
        name: "CS6W-520MB-AG",
        width: 1.159,
        height: 2.266,
        weight: 32.2,
        voc: 48.4,
        isc: 13.7,
        pMax: 520,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 20.2,
        tSTC: 30,
        panelSheet1: "../images/panels/Canadian/520-550-1.jpg",
        panelSheet2: "../images/panels/Canadian/520-550-2.jpg",
      },
      {
        name: "CS6W-525MB-AG",
        width: 1.159,
        height: 2.266,
        weight: 32.2,
        voc: 48.6,
        isc: 13.75,
        pMax: 525,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 20.4,
        tSTC: 30,
        panelSheet1: "../images/panels/Canadian/520-550-1.jpg",
        panelSheet2: "../images/panels/Canadian/520-550-2.jpg",
      },
      {
        name: "CS6W-530MB-AG",
        width: 1.159,
        height: 2.266,
        weight: 32.2,
        voc: 48.8,
        isc: 13.8,
        pMax: 530,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 20.6,
        tSTC: 30,
        panelSheet1: "../images/panels/Canadian/520-550-1.jpg",
        panelSheet2: "../images/panels/Canadian/520-550-2.jpg",
      },
      {
        name: "CS6W-535MB-AG",
        width: 1.159,
        height: 2.266,
        weight: 32.2,
        voc: 49,
        isc: 13.85,
        pMax: 535,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 20.8,
        tSTC: 30,
        panelSheet1: "../images/panels/Canadian/520-550-1.jpg",
        panelSheet2: "../images/panels/Canadian/520-550-2.jpg",
      },
      {
        name: "CS6W-540MB-AG",
        width: 1.159,
        height: 2.266,
        weight: 32.2,
        voc: 49.2,
        isc: 13.9,
        pMax: 540,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21,
        tSTC: 30,
        panelSheet1: "../images/panels/Canadian/520-550-1.jpg",
        panelSheet2: "../images/panels/Canadian/520-550-2.jpg",
      },
      {
        name: "CS6W-545MB-AG",
        width: 1.159,
        height: 2.266,
        weight: 32.2,
        voc: 49.4,
        isc: 13.95,
        pMax: 545,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.2,
        tSTC: 30,
        panelSheet1: "../images/panels/Canadian/520-550-1.jpg",
        panelSheet2: "../images/panels/Canadian/520-550-2.jpg",
      },
      {
        name: "CS6W-550MB-AG",
        width: 1.159,
        height: 2.266,
        weight: 32.2,
        voc: 49.6,
        isc: 14,
        pMax: 550,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.4,
        tSTC: 30,
        panelSheet1: "../images/panels/Canadian/520-550-1.jpg",
        panelSheet2: "../images/panels/Canadian/520-550-2.jpg",
      },

      {
        name: "CS7L-580MB-AG",
        width: 1.303,
        height: 2.172,
        weight: 34.5,
        voc: 40.5,
        isc: 18.27,
        pMax: 580,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 20.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Canadian/CS7L-580-610-1.jpg",
        panelSheet2: "../images/panels/Canadian/CS7L-580-610-2.jpg",
      },
      {
        name: "CS7L-585MB-AG",
        width: 1.303,
        height: 2.172,
        weight: 34.5,
        voc: 40.7,
        isc: 18.32,
        pMax: 585,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 20.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Canadian/CS7L-580-610-1.jpg",
        panelSheet2: "../images/panels/Canadian/CS7L-580-610-2.jpg",
      },
      {
        name: "CS7L-590MB-AG",
        width: 1.303,
        height: 2.172,
        weight: 34.5,
        voc: 40.9,
        isc: 18.37,
        pMax: 590,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 20.8,
        tSTC: 25,
        panelSheet1: "../images/panels/Canadian/CS7L-580-610-1.jpg",
        panelSheet2: "../images/panels/Canadian/CS7L-580-610-2.jpg",
      },
      {
        name: "CS7L-595MB-AG",
        width: 1.303,
        height: 2.172,
        weight: 34.5,
        voc: 41.1,
        isc: 18.42,
        pMax: 595,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.0,
        tSTC: 25,
        panelSheet1: "../images/panels/Canadian/CS7L-580-610-1.jpg",
        panelSheet2: "../images/panels/Canadian/CS7L-580-610-2.jpg",
      },
      {
        name: "CS7L-600MB-AG",
        width: 1.303,
        height: 2.172,
        weight: 34.5,
        voc: 41.3,
        isc: 18.47,
        pMax: 600,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.2,
        tSTC: 25,
        panelSheet1: "../images/panels/Canadian/CS7L-580-610-1.jpg",
        panelSheet2: "../images/panels/Canadian/CS7L-580-610-2.jpg",
      },
      {
        name: "CS7L-605MB-AG",
        width: 1.303,
        height: 2.172,
        weight: 34.5,
        voc: 41.5,
        isc: 18.52,
        pMax: 605,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.4,
        tSTC: 25,
        panelSheet1: "../images/panels/Canadian/CS7L-580-610-1.jpg",
        panelSheet2: "../images/panels/Canadian/CS7L-580-610-2.jpg",
      },
      {
        name: "CS7L-610MB-AG",
        width: 1.303,
        height: 2.172,
        weight: 34.5,
        voc: 41.7,
        isc: 18.57,
        pMax: 610,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.6,
        tSTC: 25,
        panelSheet1: "../images/panels/Canadian/CS7L-580-610-1.jpg",
        panelSheet2: "../images/panels/Canadian/CS7L-580-610-2.jpg",
      },
    ],
  },

  {
    brand: "Crown",
    panelType: [
      {
        name: "CROWN N-Type-565W",
        width: 1.134,
        height: 2.279,
        weight: 32,
        voc: 51.12,
        isc: 13.99,
        pMax: 565,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 21.86,
        tSTC: 25,
        panelSheet1: "../images/panels/Crown/565-590-1.jpg",
        panelSheet2: "../images/panels/Crown/565-590-2.jpg",
      },
      {
        name: "CROWN N-Type-570W",
        width: 1.134,
        height: 2.279,
        weight: 32,
        voc: 51.27,
        isc: 14.05,
        pMax: 570,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22.06,
        tSTC: 25,
        panelSheet1: "../images/panels/Crown/565-590-1.jpg",
        panelSheet2: "../images/panels/Crown/565-590-2.jpg",
      },
      {
        name: "CROWN N-Type-575W",
        width: 1.134,
        height: 2.279,
        weight: 32,
        voc: 51.42,
        isc: 14.11,
        pMax: 575,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22.25,
        tSTC: 25,
        panelSheet1: "../images/panels/Crown/565-590-1.jpg",
        panelSheet2: "../images/panels/Crown/565-590-2.jpg",
      },
      {
        name: "CROWN N-Type-580W",
        width: 1.134,
        height: 2.279,
        weight: 32,
        voc: 51.57,
        isc: 14.18,
        pMax: 580,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22.44,
        tSTC: 25,
        panelSheet1: "../images/panels/Crown/565-590-1.jpg",
        panelSheet2: "../images/panels/Crown/565-590-2.jpg",
      },
      {
        name: "CROWN N-Type-585W",
        width: 1.134,
        height: 2.279,
        weight: 32,
        voc: 51.72,
        isc: 14.24,
        pMax: 585,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22.64,
        tSTC: 25,
        panelSheet1: "../images/panels/Crown/565-590-1.jpg",
        panelSheet2: "../images/panels/Crown/565-590-2.jpg",
      },
      {
        name: "CROWN N-Type-590W",
        width: 1.134,
        height: 2.279,
        weight: 32,
        voc: 51.8,
        isc: 14.26,
        pMax: 590,
        tkVoc: -0.25,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22.84,
        tSTC: 25,
        panelSheet1: "../images/panels/Crown/565-590-1.jpg",
        panelSheet2: "../images/panels/Crown/565-590-2.jpg",
      },
    ],
  },

  {
    brand: "Hyundai",
    panelType: [
      {
        name: "HiE-S475VI",
        width: 1.14,
        height: 2.056,
        weight: 25,
        voc: 46.5,
        isc: 13.1,
        pMax: 475,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Hyundai/575-485-1.jpg",
        panelSheet2: "../images/panels/Hyundai/575-485-2.jpg",
      },
      {
        name: "HiE-S480VI",
        width: 1.14,
        height: 2.056,
        weight: 25,
        voc: 46.6,
        isc: 13.16,
        pMax: 480,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Hyundai/575-485-1.jpg",
        panelSheet2: "../images/panels/Hyundai/575-485-2.jpg",
      },
      {
        name: "HiE-S485VI",
        width: 1.14,
        height: 2.056,
        weight: 25,
        voc: 46.6,
        isc: 13.22,
        pMax: 485,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Hyundai/575-485-1.jpg",
        panelSheet2: "../images/panels/Hyundai/575-485-2.jpg",
      },

       {
        name: "HiT-H705GH-ZB",
        width: 1.303,
        height: 2.384,
        weight: 38.1,
        voc: 49.87,
        isc: 17.90,
        pMax: 705,
        tkVoc: -0.22,
        tkIsc: 0.04,
        tkPmax: -0.24,
        efficiency: 22.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-1.jpg",
        panelSheet2: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-2.jpg",
      },
      {
        name: "HiT-H710GH-ZB",
        width: 1.303,
        height: 2.384,
        weight: 38.1,
        voc: 49.97,
        isc: 17.99,
        pMax: 710,
        tkVoc: -0.22,
        tkIsc: 0.04,
        tkPmax: -0.24,
        efficiency: 22.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-1.jpg",
        panelSheet2: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-2.jpg",
      },
      {
        name: "HiT-H715GH-ZB",
        width: 1.303,
        height: 2.384,
        weight: 38.1,
        voc: 50.07,
        isc: 18.08,
        pMax: 715,
        tkVoc: -0.22,
        tkIsc: 0.04,
        tkPmax: -0.24,
        efficiency: 23,
        tSTC: 25,
        panelSheet1: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-1.jpg",
        panelSheet2: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-2.jpg",
      },
      {
        name: "HiT-H720GH-ZB",
        width: 1.303,
        height: 2.384,
        weight: 38.1,
        voc: 50.17,
        isc: 18.17,
        pMax: 720,
        tkVoc: -0.22,
        tkIsc: 0.04,
        tkPmax: -0.24,
        efficiency: 23.2,
        tSTC: 25,
        panelSheet1: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-1.jpg",
        panelSheet2: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-2.jpg",
      },
      {
        name: "HiT-H725GH-ZB",
        width: 1.303,
        height: 2.384,
        weight: 38.1,
        voc: 50.27,
        isc: 18.26,
        pMax: 725,
        tkVoc: -0.22,
        tkIsc: 0.04,
        tkPmax: -0.24,
        efficiency: 23.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-1.jpg",
        panelSheet2: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-2.jpg",
      },
      {
        name: "HiT-H730GH-ZB",
        width: 1.303,
        height: 2.384,
        weight: 38.1,
        voc: 50.37,
        isc: 18.35,
        pMax: 730,
        tkVoc: -0.22,
        tkIsc: 0.04,
        tkPmax: -0.24,
        efficiency: 23.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-1.jpg",
        panelSheet2: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-2.jpg",
      },
      {
        name: "HiT-H735GH-ZB",
        width: 1.303,
        height: 2.384,
        weight: 38.1,
        voc: 50.47,
        isc: 18.44,
        pMax: 735,
        tkVoc: -0.22,
        tkIsc: 0.04,
        tkPmax: -0.24,
        efficiency: 23.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-1.jpg",
        panelSheet2: "../images/panels/Hyundai/HiT-HxxxGH-ZB-705-735-2.jpg",
      },
    ],
  },

  {
    brand: "HUASUN",
    panelType: [
      {
        name: "HS-182-B144 DS580",
        width: 1.134,
        height: 2.278,
        weight: 32,
        voc: 53.92,
        isc: 13.35,
        pMax: 580,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.26,
        efficiency: 22.45,
        tSTC: 25,
        panelSheet1: "../images/panels/Huasun/580-600-1.png",
        panelSheet2: "../images/panels/Huasun/580-600-2.png",
      },
      {
        name: "HS-182-B144 DS585",
        width: 1.134,
        height: 2.278,
        weight: 32,
        voc: 54.12,
        isc: 13.4,
        pMax: 585,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.26,
        efficiency: 22.65,
        tSTC: 25,
        panelSheet1: "../images/panels/Huasun/580-600-1.png",
        panelSheet2: "../images/panels/Huasun/580-600-2.png",
      },
      {
        name: "HS-182-B144 DS590",
        width: 1.134,
        height: 2.278,
        weight: 32,
        voc: 54.31,
        isc: 13.45,
        pMax: 590,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.26,
        efficiency: 22.84,
        tSTC: 25,
        panelSheet1: "../images/panels/Huasun/580-600-1.png",
        panelSheet2: "../images/panels/Huasun/580-600-2.png",
      },
      {
        name: "HS-182-B144 DS595",
        width: 1.134,
        height: 2.278,
        weight: 32,
        voc: 54.5,
        isc: 13.5,
        pMax: 595,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.26,
        efficiency: 23.03,
        tSTC: 25,
        panelSheet1: "../images/panels/Huasun/580-600-1.png",
        panelSheet2: "../images/panels/Huasun/580-600-2.png",
      },
      {
        name: "HS-182-B144 DS600",
        width: 1.134,
        height: 2.278,
        weight: 32,
        voc: 54.7,
        isc: 13.55,
        pMax: 600,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.26,
        efficiency: 23.23,
        tSTC: 25,
        panelSheet1: "../images/panels/Huasun/580-600-1.png",
        panelSheet2: "../images/panels/Huasun/580-600-2.png",
      },
      {
        name: "HS-210-B132 DS700",
        width: 1.328,
        height: 2.384,
        weight: 38.7,
        voc: 50.28,
        isc: 17.43,
        pMax: 700,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.26,
        efficiency: 22.53,
        tSTC: 35,
        panelSheet1: "../images/panels/Huasun/700-720-1.jpg",
        panelSheet2: "../images/panels/Huasun/700-720-2.jpg",
      },
      {
        name: "HS-210-B132 DS705",
        width: 1.328,
        height: 2.384,
        weight: 38.7,
        voc: 50.29,
        isc: 17.49,
        pMax: 705,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.26,
        efficiency: 22.7,
        tSTC: 35,
        panelSheet1: "../images/panels/Huasun/700-720-1.jpg",
        panelSheet2: "../images/panels/Huasun/700-720-2.jpg",
      },
      {
        name: "HS-210-B132 DS710",
        width: 1.328,
        height: 2.384,
        weight: 38.7,
        voc: 50.44,
        isc: 17.55,
        pMax: 710,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.26,
        efficiency: 22.86,
        tSTC: 35,
        panelSheet1: "../images/panels/Huasun/700-720-1.jpg",
        panelSheet2: "../images/panels/Huasun/700-720-2.jpg",
      },
      {
        name: "HS-210-B132 DS715",
        width: 1.328,
        height: 2.384,
        weight: 38.7,
        voc: 50.59,
        isc: 17.61,
        pMax: 715,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.26,
        efficiency: 23.02,
        tSTC: 35,
        panelSheet1: "../images/panels/Huasun/700-720-1.jpg",
        panelSheet2: "../images/panels/Huasun/700-720-2.jpg",
      },
      {
        name: "HS-210-B132 DS720",
        width: 1.328,
        height: 2.384,
        weight: 38.7,
        voc: 50.74,
        isc: 17.67,
        pMax: 720,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.26,
        efficiency: 23.18,
        tSTC: 35,
        panelSheet1: "../images/panels/Huasun/700-720-1.jpg",
        panelSheet2: "../images/panels/Huasun/700-720-2.jpg",
      },
    ],
  },

  {
    brand: "HANERSUN",
    panelType: [
      {
        name: "HN18N-72HT570W",
        width: 1.134,
        height: 2.278,
        weight: 32.5,
        voc: 51.0,
        isc: 14.11,
        pMax: 570,
        tkVoc: -0.26,
        tkIsc: 0.045,
        tkPmax: -0.31,
        efficiency: 22.07,
        tSTC: 25,
        panelSheet1: "../images/panels/HANERSUN/570-590-1.jpg",
        panelSheet2: "../images/panels/HANERSUN/570-590-2.jpg",
      },
      {
        name: "HN18N-72HT575W",
        width: 1.134,
        height: 2.278,
        weight: 32.5,
        voc: 51.2,
        isc: 14.17,
        pMax: 575,
        tkVoc: -0.26,
        tkIsc: 0.045,
        tkPmax: -0.31,
        efficiency: 22.26,
        tSTC: 25,
        panelSheet1: "../images/panels/HANERSUN/570-590-1.jpg",
        panelSheet2: "../images/panels/HANERSUN/570-590-2.jpg",
      },
      {
        name: "HN18N-72HT580W",
        width: 1.134,
        height: 2.278,
        weight: 32.5,
        voc: 51.4,
        isc: 14.23,
        pMax: 580,
        tkVoc: -0.26,
        tkIsc: 0.045,
        tkPmax: -0.31,
        efficiency: 22.45,
        tSTC: 25,
        panelSheet1: "../images/panels/HANERSUN/570-590-1.jpg",
        panelSheet2: "../images/panels/HANERSUN/570-590-2.jpg",
      },
      {
        name: "HN18N-72HT585W",
        width: 1.134,
        height: 2.278,
        weight: 32.5,
        voc: 51.6,
        isc: 14.3,
        pMax: 585,
        tkVoc: -0.26,
        tkIsc: 0.045,
        tkPmax: -0.31,
        efficiency: 22.65,
        tSTC: 25,
        panelSheet1: "../images/panels/HANERSUN/570-590-1.jpg",
        panelSheet2: "../images/panels/HANERSUN/570-590-2.jpg",
      },
      {
        name: "HN18N-72HT590W",
        width: 1.134,
        height: 2.278,
        weight: 32.5,
        voc: 51.8,
        isc: 14.35,
        pMax: 590,
        tkVoc: -0.26,
        tkIsc: 0.045,
        tkPmax: -0.31,
        efficiency: 22.84,
        tSTC: 25,
        panelSheet1: "../images/panels/HANERSUN/570-590-1.jpg",
        panelSheet2: "../images/panels/HANERSUN/570-590-2.jpg",
      },
      {
        name: "HN21N-66HT680W",
        width: 1.304,
        height: 2.384,
        weight: 38.7,
        voc: 47.4,
        isc: 18.18,
        pMax: 680,
        tkVoc: -0.25,
        tkIsc: 0.04,
        tkPmax: -0.31,
        efficiency: 21.89,
        tSTC: 25,
        panelSheet1: "../images/panels/HANERSUN/680-700-1.jpg",
        panelSheet2: "../images/panels/HANERSUN/680-700-2.jpg",
      },
      {
        name: "HN21N-66HT685W",
        width: 1.304,
        height: 2.384,
        weight: 38.7,
        voc: 47.6,
        isc: 18.22,
        pMax: 685,
        tkVoc: -0.25,
        tkIsc: 0.04,
        tkPmax: -0.31,
        efficiency: 22.05,
        tSTC: 25,
        panelSheet1: "../images/panels/HANERSUN/680-700-1.jpg",
        panelSheet2: "../images/panels/HANERSUN/680-700-2.jpg",
      },
      {
        name: "HN21N-66HT690W",
        width: 1.304,
        height: 2.384,
        weight: 38.7,
        voc: 47.8,
        isc: 18.26,
        pMax: 690,
        tkVoc: -0.25,
        tkIsc: 0.04,
        tkPmax: -0.31,
        efficiency: 22.21,
        tSTC: 25,
        panelSheet1: "../images/panels/HANERSUN/680-700-1.jpg",
        panelSheet2: "../images/panels/HANERSUN/680-700-2.jpg",
      },
      {
        name: "HN21N-66HT695W",
        width: 1.304,
        height: 2.384,
        weight: 38.7,
        voc: 48.0,
        isc: 18.3,
        pMax: 695,
        tkVoc: -0.25,
        tkIsc: 0.04,
        tkPmax: -0.31,
        efficiency: 22.37,
        tSTC: 25,
        panelSheet1: "../images/panels/HANERSUN/680-700-1.jpg",
        panelSheet2: "../images/panels/HANERSUN/680-700-2.jpg",
      },
      {
        name: "HN21N-66HT700W",
        width: 1.304,
        height: 2.384,
        weight: 38.7,
        voc: 48.2,
        isc: 18.34,
        pMax: 700,
        tkVoc: -0.25,
        tkIsc: 0.04,
        tkPmax: -0.31,
        efficiency: 22.53,
        tSTC: 25,
        panelSheet1: "../images/panels/HANERSUN/680-700-1.jpg",
        panelSheet2: "../images/panels/HANERSUN/680-700-2.jpg",
      },
    ],
  },

  {
    brand: "JA Solar",
    panelType: [
      {
        name: "JAM72S30-525/MR",
        width: 1.159,
        height: 2.279,
        weight: 28.6,
        voc: 49.15,
        isc: 13.65,
        pMax: 525,
        tkVoc: -0.275,
        tkIsc: 0.045,
        tkPmax: -0.35,
        efficiency: 20.3,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/525-550-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/525-550-2.jpg",
      },
      {
        name: "JAM72S30-530/MR",
        width: 1.159,
        height: 2.279,
        weight: 28.6,
        voc: 49.3,
        isc: 13.72,
        pMax: 530,
        tkVoc: -0.275,
        tkIsc: 0.045,
        tkPmax: -0.35,
        efficiency: 20.5,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/525-550-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/525-550-2.jpg",
      },
      {
        name: "JAM72S30-535/MR",
        width: 1.159,
        height: 2.279,
        weight: 28.6,
        voc: 49.45,
        isc: 13.79,
        pMax: 535,
        tkVoc: -0.275,
        tkIsc: 0.045,
        tkPmax: -0.35,
        efficiency: 20.7,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/525-550-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/525-550-2.jpg",
      },
      {
        name: "JAM72S30-540/MR",
        width: 1.159,
        height: 2.279,
        weight: 28.6,
        voc: 49.6,
        isc: 13.86,
        pMax: 540,
        tkVoc: -0.275,
        tkIsc: 0.045,
        tkPmax: -0.35,
        efficiency: 20.9,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/525-550-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/525-550-2.jpg",
      },
      {
        name: "JAM72S30-545/MR",
        width: 1.159,
        height: 2.279,
        weight: 28.6,
        voc: 49.75,
        isc: 13.93,
        pMax: 545,
        tkVoc: -0.275,
        tkIsc: 0.045,
        tkPmax: -0.35,
        efficiency: 21.1,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/525-550-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/525-550-2.jpg",
      },
      {
        name: "JAM72S30-550/MR",
        width: 1.159,
        height: 2.279,
        weight: 28.6,
        voc: 49.9,
        isc: 14,
        pMax: 550,
        tkVoc: -0.275,
        tkIsc: 0.045,
        tkPmax: -0.35,
        efficiency: 21.3,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/525-550-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/525-550-2.jpg",
      },

      {
        name: "JAM72D42-605/LB",
        width: 1.134,
        height: 2.456,
        weight: 34.6,
        voc: 51.27,
        isc: 14.83,
        pMax: 605,
        tkVoc: -0.26,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 21.6,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/605-630LB-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/605-630LB-2.jpg",
      },
      {
        name: "JAM72D42-610/LB",
        width: 1.134,
        height: 2.456,
        weight: 34.6,
        voc: 51.47,
        isc: 14.88,
        pMax: 610,
        tkVoc: -0.26,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 21.8,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/605-630LB-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/605-630LB-2.jpg",
      },
      {
        name: "JAM72D42-615/LB",
        width: 1.134,
        height: 2.456,
        weight: 34.6,
        voc: 51.67,
        isc: 14.93,
        pMax: 615,
        tkVoc: -0.26,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/605-630LB-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/605-630LB-2.jpg",
      },
      {
        name: "JAM72D42-620/LB",
        width: 1.134,
        height: 2.456,
        weight: 34.6,
        voc: 51.86,
        isc: 14.98,
        pMax: 620,
        tkVoc: -0.26,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22.2,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/605-630LB-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/605-630LB-2.jpg",
      },
      {
        name: "JAM72D42-625/LB",
        width: 1.134,
        height: 2.456,
        weight: 34.6,
        voc: 52.05,
        isc: 15.03,
        pMax: 625,
        tkVoc: -0.26,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22.4,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/605-630LB-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/605-630LB-2.jpg",
      },
      {
        name: "JAM72D42-630/LB",
        width: 1.134,
        height: 2.456,
        weight: 34.6,
        voc: 52.24,
        isc: 15.08,
        pMax: 630,
        tkVoc: -0.26,
        tkIsc: 0.046,
        tkPmax: -0.3,
        efficiency: 22.5,
        tSTC: 25,
        panelSheet1: "../images/panels/JA-Solar/605-630LB-1.jpg",
        panelSheet2: "../images/panels/JA-Solar/605-630LB-2.jpg",
      },
    ],
  },

  {
    brand: "Jinko",
    panelType: [
      {
        name: "JKM535M-72HL4-BDVP",
        width: 1.134,
        height: 2.278,
        weight: 32,
        voc: 49.54,
        isc: 13.83,
        pMax: 535,
        tkVoc: -0.28,
        tkIsc: 0.048,
        tkPmax: -0.35,
        efficiency: 20.71,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/535-555M-72HL4-BDVP-1.jpg",
        panelSheet2: "../images/panels/Jinko/535-555M-72HL4-BDVP-2.jpg",
      },
      {
        name: "JKM540M-72HL4-BDVP",
        width: 1.134,
        height: 2.278,
        weight: 32,
        voc: 49.73,
        isc: 13.89,
        pMax: 540,
        tkVoc: -0.28,
        tkIsc: 0.048,
        tkPmax: -0.35,
        efficiency: 20.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/535-555M-72HL4-BDVP-1.jpg",
        panelSheet2: "../images/panels/Jinko/535-555M-72HL4-BDVP-2.jpg",
      },
      {
        name: "JKM545M-72HL4-BDVP",
        width: 1.134,
        height: 2.278,
        weight: 32,
        voc: 49.92,
        isc: 13.95,
        pMax: 545,
        tkVoc: -0.28,
        tkIsc: 0.048,
        tkPmax: -0.35,
        efficiency: 21.1,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/535-555M-72HL4-BDVP-1.jpg",
        panelSheet2: "../images/panels/Jinko/535-555M-72HL4-BDVP-2.jpg",
      },
      {
        name: "JKM550M-72HL4-BDVP",
        width: 1.134,
        height: 2.278,
        weight: 32,
        voc: 50.11,
        isc: 14.01,
        pMax: 550,
        tkVoc: -0.28,
        tkIsc: 0.048,
        tkPmax: -0.35,
        efficiency: 21.29,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/535-555M-72HL4-BDVP-1.jpg",
        panelSheet2: "../images/panels/Jinko/535-555M-72HL4-BDVP-2.jpg",
      },
      {
        name: "JKM555M-72HL4-BDVP",
        width: 1.134,
        height: 2.278,
        weight: 32,
        voc: 50.3,
        isc: 14.07,
        pMax: 555,
        tkVoc: -0.28,
        tkIsc: 0.048,
        tkPmax: -0.35,
        efficiency: 21.48,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/535-555M-72HL4-BDVP-1.jpg",
        panelSheet2: "../images/panels/Jinko/535-555M-72HL4-BDVP-2.jpg",
      },

      {
        name: "JKM-550M-72HL4-V",
        width: 1.134,
        height: 2.278,
        weight: 27,
        voc: 49.62,
        isc: 14.03,
        pMax: 550,
        tkVoc: -0.28,
        tkIsc: 0.048,
        tkPmax: -0.35,
        efficiency: 21.29,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/550-570M-72HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/550-570M-72HL4-V-2.jpg",
      },
      {
        name: "JKM-555M-72HL4-V",
        width: 1.134,
        height: 2.278,
        weight: 27,
        voc: 49.72,
        isc: 14.12,
        pMax: 555,
        tkVoc: -0.28,
        tkIsc: 0.048,
        tkPmax: -0.35,
        efficiency: 21.48,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/550-570M-72HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/550-570M-72HL4-V-2.jpg",
      },
      {
        name: "JKM-560M-72HL4-V",
        width: 1.134,
        height: 2.278,
        weight: 27,
        voc: 49.82,
        isc: 14.21,
        pMax: 560,
        tkVoc: -0.28,
        tkIsc: 0.048,
        tkPmax: -0.35,
        efficiency: 21.68,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/550-570M-72HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/550-570M-72HL4-V-2.jpg",
      },
      {
        name: "JKM-565M-72HL4-V",
        width: 1.134,
        height: 2.278,
        weight: 27,
        voc: 49.93,
        isc: 14.3,
        pMax: 565,
        tkVoc: -0.28,
        tkIsc: 0.048,
        tkPmax: -0.35,
        efficiency: 21.87,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/550-570M-72HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/550-570M-72HL4-V-2.jpg",
      },
      {
        name: "JKM-570M-72HL4-V",
        width: 1.134,
        height: 2.278,
        weight: 27,
        voc: 50.04,
        isc: 14.39,
        pMax: 570,
        tkVoc: -0.28,
        tkIsc: 0.048,
        tkPmax: -0.35,
        efficiency: 22.07,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/550-570M-72HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/550-570M-72HL4-V-2.jpg",
      },

      {
        name: "JKM-570N-72HL4-V",
        width: 1.134,
        height: 2.278,
        weight: 27,
        voc: 51.99,
        isc: 13.89,
        pMax: 570,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.07,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/570-590N-72HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/570-590N-72HL4-V-2.jpg",
      },
      {
        name: "JKM-575N-72HL4-V",
        width: 1.134,
        height: 2.278,
        weight: 27,
        voc: 52.15,
        isc: 13.95,
        pMax: 575,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.26,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/570-590N-72HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/570-590N-72HL4-V-2.jpg",
      },
      {
        name: "JKM-580N-72HL4-V",
        width: 1.134,
        height: 2.278,
        weight: 27,
        voc: 52.31,
        isc: 14.01,
        pMax: 580,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.45,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/570-590N-72HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/570-590N-72HL4-V-2.jpg",
      },
      {
        name: "JKM-585N-72HL4-V",
        width: 1.134,
        height: 2.278,
        weight: 27,
        voc: 52.47,
        isc: 14.07,
        pMax: 585,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.65,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/570-590N-72HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/570-590N-72HL4-V-2.jpg",
      },
      {
        name: "JKM-590N-72HL4-V",
        width: 1.134,
        height: 2.278,
        weight: 27,
        voc: 52.63,
        isc: 14.13,
        pMax: 590,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.84,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/570-590N-72HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/570-590N-72HL4-V-2.jpg",
      },

      {
        name: "JKM-570N-72HL4-BDV",
        width: 1.134,
        height: 2.278,
        weight: 31,
        voc: 52.1,
        isc: 13.83,
        pMax: 570,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.07,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/570-590N-72HL4-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/570-590N-72HL4-BDV-2.jpg",
      },
      {
        name: "JKM-575N-72HL4-BDV",
        width: 1.134,
        height: 2.278,
        weight: 31,
        voc: 52.3,
        isc: 13.89,
        pMax: 575,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.26,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/570-590N-72HL4-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/570-590N-72HL4-BDV-2.jpg",
      },
      {
        name: "JKM-580N-72HL4-BDV",
        width: 1.134,
        height: 2.278,
        weight: 31,
        voc: 52.5,
        isc: 13.95,
        pMax: 580,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.45,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/570-590N-72HL4-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/570-590N-72HL4-BDV-2.jpg",
      },
      {
        name: "JKM-585N-72HL4-BDV",
        width: 1.134,
        height: 2.278,
        weight: 31,
        voc: 52.7,
        isc: 14.01,
        pMax: 585,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.65,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/570-590N-72HL4-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/570-590N-72HL4-BDV-2.jpg",
      },
      {
        name: "JKM-590N-72HL4-BDV",
        width: 1.134,
        height: 2.278,
        weight: 31,
        voc: 52.9,
        isc: 14.07,
        pMax: 590,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.84,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/570-590N-72HL4-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/570-590N-72HL4-BDV-2.jpg",
      },

      {
        name: "JKM595N-78HL4",
        width: 1.134,
        height: 2.465,
        weight: 30.6,
        voc: 54.08,
        isc: 13.9,
        pMax: 595,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.3,
        efficiency: 21.29,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/595-615-78HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/595-615-78HL4-V-2.jpg",
      },
      {
        name: "JKM600N-78HL4",
        width: 1.134,
        height: 2.465,
        weight: 30.6,
        voc: 54.95,
        isc: 13.97,
        pMax: 600,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.3,
        efficiency: 21.46,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/595-615-78HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/595-615-78HL4-V-2.jpg",
      },
      {
        name: "JKM605N-78HL4",
        width: 1.134,
        height: 2.465,
        weight: 30.6,
        voc: 55.1,
        isc: 14.04,
        pMax: 605,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.3,
        efficiency: 21.64,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/595-615-78HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/595-615-78HL4-V-2.jpg",
      },
      {
        name: "JKM610N-78HL4",
        width: 1.134,
        height: 2.465,
        weight: 30.6,
        voc: 55.25,
        isc: 14.11,
        pMax: 610,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.3,
        efficiency: 21.82,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/595-615-78HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/595-615-78HL4-V-2.jpg",
      },
      {
        name: "JKM615N-78HL4",
        width: 1.134,
        height: 2.465,
        weight: 30.6,
        voc: 55.4,
        isc: 14.18,
        pMax: 615,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.3,
        efficiency: 22,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/595-615-78HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/595-615-78HL4-V-2.jpg",
      },

      {
        name: "JKM-600N-66HL4M-BDV",
        width: 1.134,
        height: 2.382,
        weight: 32.4,
        voc: 48.28,
        isc: 15.84,
        pMax: 600,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.21,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/600-625N-66HL4M-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/600-625N-66HL4M-BDV-2.jpg",
      },
      {
        name: "JKM-605N-66HL4M-BDV",
        width: 1.134,
        height: 2.382,
        weight: 32.4,
        voc: 48.48,
        isc: 15.9,
        pMax: 605,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.4,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/600-625N-66HL4M-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/600-625N-66HL4M-BDV-2.jpg",
      },
      {
        name: "JKM-610N-66HL4M-BDV",
        width: 1.134,
        height: 2.382,
        weight: 32.4,
        voc: 48.68,
        isc: 15.96,
        pMax: 610,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.58,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/600-625N-66HL4M-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/600-625N-66HL4M-BDV-2.jpg",
      },
      {
        name: "JKM-615N-66HL4M-BDV",
        width: 1.134,
        height: 2.382,
        weight: 32.4,
        voc: 48.88,
        isc: 16.02,
        pMax: 615,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.77,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/600-625N-66HL4M-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/600-625N-66HL4M-BDV-2.jpg",
      },
      {
        name: "JKM-620N-66HL4M-BDV",
        width: 1.134,
        height: 2.382,
        weight: 32.4,
        voc: 49.08,
        isc: 16.08,
        pMax: 620,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.95,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/600-625N-66HL4M-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/600-625N-66HL4M-BDV-2.jpg",
      },
      {
        name: "JKM-625N-66HL4M-BDV",
        width: 1.134,
        height: 2.382,
        weight: 32.4,
        voc: 49.28,
        isc: 16.14,
        pMax: 625,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 23.14,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/600-625N-66HL4M-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/600-625N-66HL4M-BDV-2.jpg",
      },

      {
        name: "JKM-605N-66HL4M-V",
        width: 1.134,
        height: 2.382,
        weight: 28.2,
        voc: 48.47,
        isc: 15.94,
        pMax: 605,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.4,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/605-630N-66HL4M-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/605-630N-66HL4M-V-2.jpg",
      },
      {
        name: "JKM-610N-66HL4M-V",
        width: 1.134,
        height: 2.382,
        weight: 28.2,
        voc: 48.63,
        isc: 16.01,
        pMax: 610,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.58,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/605-630N-66HL4M-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/605-630N-66HL4M-V-2.jpg",
      },
      {
        name: "JKM-615N-66HL4M-V",
        width: 1.134,
        height: 2.382,
        weight: 28.2,
        voc: 48.79,
        isc: 16.08,
        pMax: 615,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.77,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/605-630N-66HL4M-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/605-630N-66HL4M-V-2.jpg",
      },
      {
        name: "JKM-620N-66HL4M-V",
        width: 1.134,
        height: 2.382,
        weight: 28.2,
        voc: 48.95,
        isc: 16.15,
        pMax: 620,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.95,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/605-630N-66HL4M-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/605-630N-66HL4M-V-2.jpg",
      },
      {
        name: "JKM-625N-66HL4M-V",
        width: 1.134,
        height: 2.382,
        weight: 28.2,
        voc: 49.11,
        isc: 16.22,
        pMax: 625,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 23.14,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/605-630N-66HL4M-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/605-630N-66HL4M-V-2.jpg",
      },
      {
        name: "JKM-630N-66HL4M-V",
        width: 1.134,
        height: 2.382,
        weight: 28.2,
        voc: 49.27,
        isc: 16.29,
        pMax: 625,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 23.32,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/605-630N-66HL4M-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/605-630N-66HL4M-V-2.jpg",
      },

      {
        name: "JKM-615N-78HL4-V",
        width: 1.134,
        height: 2.465,
        weight: 29.5,
        voc: 56.25,
        isc: 13.8,
        pMax: 615,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/615-635N-78HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/615-635N-78HL4-V-2.jpg",
      },
      {
        name: "JKM-620N-78HL4-V",
        width: 1.134,
        height: 2.465,
        weight: 29.5,
        voc: 56.4,
        isc: 13.86,
        pMax: 620,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.18,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/615-635N-78HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/615-635N-78HL4-V-2.jpg",
      },
      {
        name: "JKM-625N-78HL4-V",
        width: 1.134,
        height: 2.465,
        weight: 29.5,
        voc: 56.55,
        isc: 13.92,
        pMax: 625,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.36,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/615-635N-78HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/615-635N-78HL4-V-2.jpg",
      },
      {
        name: "JKM-630N-78HL4-V",
        width: 1.134,
        height: 2.465,
        weight: 29.5,
        voc: 56.7,
        isc: 13.98,
        pMax: 630,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.54,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/615-635N-78HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/615-635N-78HL4-V-2.jpg",
      },
      {
        name: "JKM-635N-78HL4-V",
        width: 1.134,
        height: 2.465,
        weight: 29.5,
        voc: 56.85,
        isc: 14.04,
        pMax: 635,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.72,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/615-635N-78HL4-V-1.jpg",
        panelSheet2: "../images/panels/Jinko/615-635N-78HL4-V-2.jpg",
      },

      {
        name: "JKM-615N-78HL4-BDV",
        width: 1.134,
        height: 2.465,
        weight: 29.5,
        voc: 56.69,
        isc: 13.68,
        pMax: 615,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/615-635N-78HL4-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/615-635N-78HL4-BDV-2.jpg",
      },
      {
        name: "JKM-620N-78HL4-BDV",
        width: 1.134,
        height: 2.465,
        weight: 29.5,
        voc: 56.82,
        isc: 13.74,
        pMax: 620,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.18,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/615-635N-78HL4-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/615-635N-78HL4-BDV-2.jpg",
      },
      {
        name: "JKM-625N-78HL4-BDV",
        width: 1.134,
        height: 2.465,
        weight: 29.5,
        voc: 56.95,
        isc: 13.8,
        pMax: 625,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.36,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/615-635N-78HL4-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/615-635N-78HL4-BDV-2.jpg",
      },
      {
        name: "JKM-630N-78HL4-BDV",
        width: 1.134,
        height: 2.465,
        weight: 29.5,
        voc: 57.08,
        isc: 13.92,
        pMax: 630,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.54,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/615-635N-78HL4-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/615-635N-78HL4-BDV-2.jpg",
      },
      {
        name: "JKM-635N-78HL4-BDV",
        width: 1.134,
        height: 2.465,
        weight: 29.5,
        voc: 57.21,
        isc: 13.92,
        pMax: 635,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.72,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/615-635N-78HL4-BDV-1.jpg",
        panelSheet2: "../images/panels/Jinko/615-635N-78HL4-BDV-2.jpg",
      },

       {
        name: "JKM710N-66HL5-BDV-Z3",
        width: 1.303,
        height: 2.384,
        weight: 37.5,
        voc: 48.73,
        isc: 18.53,
        pMax: 710,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 22.86,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-1.jpg",
        panelSheet2: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-2.jpg",
      },
       {
        name: "JKM715N-66HL5-BDV-Z3",
        width: 1.303,
        height: 2.384,
        weight: 37.5,
        voc: 48.88,
        isc: 18.60,
        pMax: 715,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 23.02,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-1.jpg",
        panelSheet2: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-2.jpg",
      },
       {
        name: "JKM720N-66HL5-BDV-Z3",
        width: 1.303,
        height: 2.384,
        weight: 37.5,
        voc: 49.04,
        isc: 18.67,
        pMax: 720,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 23.18,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-1.jpg",
        panelSheet2: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-2.jpg",
      },
       {
        name: "JKM725N-66HL5-BDV-Z3",
        width: 1.303,
        height: 2.384,
        weight: 37.5,
        voc: 49.20,
        isc: 18.74,
        pMax: 725,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 23.34,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-1.jpg",
        panelSheet2: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-2.jpg",
      },
       {
        name: "JKM730N-66HL5-BDV-Z3",
        width: 1.303,
        height: 2.384,
        weight: 37.5,
        voc: 49.36,
        isc: 18.81,
        pMax: 730,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 23.50,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-1.jpg",
        panelSheet2: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-2.jpg",
      },
       {
        name: "JKM735N-66HL5-BDV-Z3",
        width: 1.303,
        height: 2.384,
        weight: 37.5,
        voc: 49.52,
        isc: 18.88,
        pMax: 735,
        tkVoc: -0.25,
        tkIsc: 0.045,
        tkPmax: -0.29,
        efficiency: 23.66,
        tSTC: 25,
        panelSheet1: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-1.jpg",
        panelSheet2: "../images/panels/Jinko/710-735N-66HL5-BDV-Z3-2.jpg",
      },
    ],
  },

  {
    brand: "Longi",
    panelType: [
      {
        name: "LR5-72HBD-530M",
        width: 1.133,
        height: 2.256,
        weight: 32.3,
        voc: 49.2,
        isc: 13.71,
        pMax: 530,
        tkVoc: -0.265,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 20.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HBD-530-550M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HBD-530-550M-2.jpg",
      },
      {
        name: "LR5-72HBD-535M",
        width: 1.133,
        height: 2.256,
        weight: 32.3,
        voc: 49.35,
        isc: 13.78,
        pMax: 535,
        tkVoc: -0.265,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 20.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HBD-530-550M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HBD-530-550M-2.jpg",
      },
      {
        name: "LR5-72HBD-540M",
        width: 1.133,
        height: 2.256,
        weight: 32.3,
        voc: 49.5,
        isc: 13.85,
        pMax: 540,
        tkVoc: -0.265,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.1,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HBD-530-550M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HBD-530-550M-2.jpg",
      },
      {
        name: "LR5-72HBD-545M",
        width: 1.133,
        height: 2.256,
        weight: 32.3,
        voc: 49.65,
        isc: 13.92,
        pMax: 545,
        tkVoc: -0.265,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HBD-530-550M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HBD-530-550M-2.jpg",
      },
      {
        name: "LR5-72HBD-550M",
        width: 1.133,
        height: 2.256,
        weight: 32.3,
        voc: 49.8,
        isc: 13.99,
        pMax: 550,
        tkVoc: -0.265,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HBD-530-550M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HBD-530-550M-2.jpg",
      },

      {
        name: "LR5-72HPH-540M",
        width: 1.134,
        height: 2.278,
        weight: 27.5,
        voc: 49.5,
        isc: 13.85,
        pMax: 540,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 20.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HPH-540-560M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HPH-540-560M-2.jpg",
      },
      {
        name: "LR5-72HPH-545M",
        width: 1.134,
        height: 2.278,
        weight: 27.5,
        voc: 49.65,
        isc: 13.92,
        pMax: 545,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.1,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HPH-540-560M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HPH-540-560M-2.jpg",
      },
      {
        name: "LR5-72HPH-550M",
        width: 1.134,
        height: 2.278,
        weight: 27.5,
        voc: 49.9,
        isc: 13.98,
        pMax: 550,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HPH-540-560M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HPH-540-560M-2.jpg",
      },
      {
        name: "LR5-72HPH-555M",
        width: 1.134,
        height: 2.278,
        weight: 27.5,
        voc: 49.95,
        isc: 14.04,
        pMax: 555,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HPH-540-560M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HPH-540-560M-2.jpg",
      },
      {
        name: "LR5-72HPH-560M",
        width: 1.134,
        height: 2.278,
        weight: 27.5,
        voc: 50.1,
        isc: 14.1,
        pMax: 560,
        tkVoc: -0.26,
        tkIsc: 0.05,
        tkPmax: -0.34,
        efficiency: 21.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HPH-540-560M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HPH-540-560M-2.jpg",
      },

      {
        name: "LR5-72HTD-550M",
        width: 1.134,
        height: 2.278,
        weight: 32.6,
        voc: 51.4,
        isc: 13.74,
        pMax: 550,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 21.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTD-550-580M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTD-550-580M-2.jpg",
      },
      {
        name: "LR5-72HTD-555M",
        width: 1.134,
        height: 2.278,
        weight: 32.6,
        voc: 51.55,
        isc: 13.8,
        pMax: 555,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 21.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTD-550-580M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTD-550-580M-2.jpg",
      },
      {
        name: "LR5-72HTD-560M",
        width: 1.134,
        height: 2.278,
        weight: 32.6,
        voc: 51.7,
        isc: 13.87,
        pMax: 560,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 21.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTD-550-580M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTD-550-580M-2.jpg",
      },
      {
        name: "LR5-72HTD-565M",
        width: 1.134,
        height: 2.278,
        weight: 32.6,
        voc: 51.85,
        isc: 13.93,
        pMax: 565,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 21.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTD-550-580M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTD-550-580M-2.jpg",
      },
      {
        name: "LR5-72HTD-570M",
        width: 1.134,
        height: 2.278,
        weight: 32.6,
        voc: 52,
        isc: 14,
        pMax: 570,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.1,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTD-550-580M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTD-550-580M-2.jpg",
      },
      {
        name: "LR5-72HTD-575M",
        width: 1.134,
        height: 2.278,
        weight: 32.6,
        voc: 52.15,
        isc: 14.06,
        pMax: 575,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTD-550-580M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTD-550-580M-2.jpg",
      },
      {
        name: "LR5-72HTD-580M",
        width: 1.134,
        height: 2.278,
        weight: 32.6,
        voc: 52.3,
        isc: 14.13,
        pMax: 580,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTD-550-580M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTD-550-580M-2.jpg",
      },

      {
        name: "LR5-72HTH-560M-30mm",
        width: 1.134,
        height: 2.278,
        weight: 27.5,
        voc: 51.61,
        isc: 13.94,
        pMax: 560,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 21.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-560-575M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-560-575M-2.jpg",
      },
      {
        name: "LR5-72HTH-565M-30mm",
        width: 1.134,
        height: 2.278,
        weight: 27.5,
        voc: 51.76,
        isc: 14.01,
        pMax: 565,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 21.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-560-575M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-560-575M-2.jpg",
      },
      {
        name: "LR5-72HTH-570M-30mm",
        width: 1.134,
        height: 2.278,
        weight: 27.2,
        voc: 51.91,
        isc: 14.07,
        pMax: 570,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.1,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-560-575M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-560-575M-2.jpg",
      },
      {
        name: "LR5-72HTH-575M-30mm",
        width: 1.134,
        height: 2.278,
        weight: 27.5,
        voc: 52.06,
        isc: 14.14,
        pMax: 575,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-560-575M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-560-575M-2.jpg",
      },

      {
        name: "LR5-72HTH-565M",
        width: 1.134,
        height: 2.278,
        weight: 27.2,
        voc: 51.76,
        isc: 14.01,
        pMax: 565,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 21.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-565-585M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-565-585M-2.jpg",
      },
      {
        name: "LR5-72HTH-570M",
        width: 1.134,
        height: 2.278,
        weight: 27.2,
        voc: 51.91,
        isc: 14.07,
        pMax: 570,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.1,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-565-585M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-565-585M-2.jpg",
      },
      {
        name: "LR5-72HTH-575M",
        width: 1.134,
        height: 2.278,
        weight: 27.2,
        voc: 52.06,
        isc: 14.14,
        pMax: 575,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-565-585M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-565-585M-2.jpg",
      },
      {
        name: "LR5-72HTH-580M",
        width: 1.134,
        height: 2.278,
        weight: 27.2,
        voc: 52.21,
        isc: 14.2,
        pMax: 580,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-565-585M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-565-585M-2.jpg",
      },
      {
        name: "LR5-72HTH-585M",
        width: 1.134,
        height: 2.278,
        weight: 27.2,
        voc: 52.36,
        isc: 14.27,
        pMax: 585,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.6,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-565-585M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-565-585M-2.jpg",
      },

      {
        name: "LR5-72HTH-590M",
        width: 1.134,
        height: 2.278,
        weight: 27.2,
        voc: 52.51,
        isc: 14.33,
        pMax: 590,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.8,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-590-600M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-590-600M-2.jpg",
      },
      {
        name: "LR5-72HTH-595M",
        width: 1.134,
        height: 2.278,
        weight: 27.2,
        voc: 52.66,
        isc: 14.4,
        pMax: 595,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 23,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-590-600M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-590-600M-2.jpg",
      },
      {
        name: "LR5-72HTH-600M",
        width: 1.134,
        height: 2.278,
        weight: 27.2,
        voc: 52.81,
        isc: 14.46,
        pMax: 600,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 23.2,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTH-590-600M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTH-590-600M-2.jpg",
      },

      {
        name: "LR5-72HTHF-565M",
        width: 1.134,
        height: 2.281,
        weight: 27.2,
        voc: 51.76,
        isc: 14.01,
        pMax: 565,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 21.8,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTHF-565-600M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTHF-565-600M-2.jpg",
      },
      {
        name: "LR5-72HTHF-570M",
        width: 1.134,
        height: 2.281,
        weight: 27.2,
        voc: 51.91,
        isc: 14.07,
        pMax: 570,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTHF-565-600M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTHF-565-600M-2.jpg",
      },
      {
        name: "LR5-72HTHF-575M",
        width: 1.134,
        height: 2.281,
        weight: 27.2,
        voc: 52.06,
        isc: 14.14,
        pMax: 575,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.2,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTHF-565-600M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTHF-565-600M-2.jpg",
      },
      {
        name: "LR5-72HTHF-580M",
        width: 1.134,
        height: 2.281,
        weight: 27.2,
        voc: 52.21,
        isc: 14.2,
        pMax: 580,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.4,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTHF-565-600M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTHF-565-600M-2.jpg",
      },
      {
        name: "LR5-72HTHF-585M",
        width: 1.134,
        height: 2.281,
        weight: 27.2,
        voc: 52.36,
        isc: 14.27,
        pMax: 585,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.6,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTHF-565-600M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTHF-565-600M-2.jpg",
      },
      {
        name: "LR5-72HTHF-590M",
        width: 1.134,
        height: 2.281,
        weight: 27.2,
        voc: 52.51,
        isc: 14.33,
        pMax: 590,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 22.8,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTHF-565-600M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTHF-565-600M-2.jpg",
      },
      {
        name: "LR5-72HTHF-595M",
        width: 1.134,
        height: 2.281,
        weight: 27.2,
        voc: 52.66,
        isc: 14.4,
        pMax: 595,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 23,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTHF-565-600M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTHF-565-600M-2.jpg",
      },
      {
        name: "LR5-72HTHF-600M",
        width: 1.134,
        height: 2.281,
        weight: 27.2,
        voc: 52.81,
        isc: 14.46,
        pMax: 600,
        tkVoc: -0.23,
        tkIsc: 0.05,
        tkPmax: -0.29,
        efficiency: 23.2,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HTHF-565-600M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HTHF-565-600M-2.jpg",
      },

      {
        name: "LR5-72HGD-560M",
        width: 1.134,
        height: 2.278,
        weight: 31.8,
        voc: 50.99,
        isc: 13.89,
        pMax: 560,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 21.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HGD-560-590M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HGD-560-590M-2.jpg",
      },
      {
        name: "LR5-72HGD-565M",
        width: 1.134,
        height: 2.278,
        weight: 31.8,
        voc: 51.09,
        isc: 13.97,
        pMax: 565,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 21.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HGD-560-590M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HGD-560-590M-2.jpg",
      },
      {
        name: "LR5-72HGD-570M",
        width: 1.134,
        height: 2.278,
        weight: 31.8,
        voc: 51.19,
        isc: 14.05,
        pMax: 570,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 22.1,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HGD-560-590M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HGD-560-590M-2.jpg",
      },
      {
        name: "LR5-72HGD-575M",
        width: 1.134,
        height: 2.278,
        weight: 31.8,
        voc: 51.3,
        isc: 14.14,
        pMax: 575,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 22.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HGD-560-590M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HGD-560-590M-2.jpg",
      },
      {
        name: "LR5-72HGD-580M",
        width: 1.134,
        height: 2.278,
        weight: 31.8,
        voc: 51.41,
        isc: 14.22,
        pMax: 580,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 22.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HGD-560-590M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HGD-560-590M-2.jpg",
      },
      {
        name: "LR5-72HGD-585M",
        width: 1.134,
        height: 2.278,
        weight: 31.8,
        voc: 51.52,
        isc: 14.3,
        pMax: 585,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 22.6,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HGD-560-590M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HGD-560-590M-2.jpg",
      },
      {
        name: "LR5-72HGD-590M",
        width: 1.134,
        height: 2.278,
        weight: 31.8,
        voc: 51.63,
        isc: 14.38,
        pMax: 590,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 22.8,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR5-72HGD-560-590M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR5-72HGD-560-590M-2.jpg",
      },

      {
        name: "LR7-72HGD-585M",
        width: 1.134,
        height: 2.382,
        weight: 33.5,
        voc: 52.01,
        isc: 14.29,
        pMax: 585,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 21.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HGD-585-620M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HGD-585-620M-2.jpg",
      },
      {
        name: "LR7-72HGD-590M",
        width: 1.134,
        height: 2.382,
        weight: 33.5,
        voc: 52.12,
        isc: 14.37,
        pMax: 590,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 21.8,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HGD-585-620M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HGD-585-620M-2.jpg",
      },
      {
        name: "LR7-72HGD-595M",
        width: 1.134,
        height: 2.382,
        weight: 33.5,
        voc: 52.23,
        isc: 14.45,
        pMax: 595,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 22,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HGD-585-620M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HGD-585-620M-2.jpg",
      },
      {
        name: "LR7-72HGD-600M",
        width: 1.134,
        height: 2.382,
        weight: 33.5,
        voc: 52.34,
        isc: 14.53,
        pMax: 600,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 22.2,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HGD-585-620M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HGD-585-620M-2.jpg",
      },
      {
        name: "LR7-72HGD-605M",
        width: 1.134,
        height: 2.382,
        weight: 33.5,
        voc: 52.44,
        isc: 14.61,
        pMax: 605,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 22.4,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HGD-585-620M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HGD-585-620M-2.jpg",
      },
      {
        name: "LR7-72HGD-610M",
        width: 1.134,
        height: 2.382,
        weight: 33.5,
        voc: 52.55,
        isc: 14.69,
        pMax: 610,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 22.6,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HGD-585-620M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HGD-585-620M-2.jpg",
      },
      {
        name: "LR7-72HGD-615M",
        width: 1.134,
        height: 2.382,
        weight: 33.5,
        voc: 52.66,
        isc: 14.77,
        pMax: 615,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 22.8,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HGD-585-620M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HGD-585-620M-2.jpg",
      },
      {
        name: "LR7-72HGD-620M",
        width: 1.134,
        height: 2.382,
        weight: 33.5,
        voc: 52.77,
        isc: 14.85,
        pMax: 620,
        tkVoc: -0.23,
        tkIsc: 0.045,
        tkPmax: -0.28,
        efficiency: 23,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HGD-585-620M-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HGD-585-620M-2.jpg",
      },

      {
        name: "LR7-72HVHX10-630M",
        width: 1.134,
        height: 2.382,
        weight: 28.5,
        voc: 53.5,
        isc: 14.97,
        pMax: 630,
        tkVoc: -0.2,
        tkIsc: 0.05,
        tkPmax: -0.26,
        efficiency: 23.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HVHX10-630-650-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HVHX10-630-650-2.jpg",
      },
      {
        name: "LR7-72HVHX10-635M",
        width: 1.134,
        height: 2.382,
        weight: 28.5,
        voc: 53.6,
        isc: 15.05,
        pMax: 635,
        tkVoc: -0.2,
        tkIsc: 0.05,
        tkPmax: -0.26,
        efficiency: 23.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HVHX10-630-650-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HVHX10-630-650-2.jpg",
      },
      {
        name: "LR7-72HVHX10-640M",
        width: 1.134,
        height: 2.382,
        weight: 28.5,
        voc: 53.7,
        isc: 15.13,
        pMax: 640,
        tkVoc: -0.2,
        tkIsc: 0.05,
        tkPmax: -0.26,
        efficiency: 23.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HVHX10-630-650-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HVHX10-630-650-2.jpg",
      },
      {
        name: "LR7-72HVHX10-645M",
        width: 1.134,
        height: 2.382,
        weight: 28.5,
        voc: 53.8,
        isc: 15.21,
        pMax: 645,
        tkVoc: -0.2,
        tkIsc: 0.05,
        tkPmax: -0.26,
        efficiency: 23.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HVHX10-630-650-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HVHX10-630-650-2.jpg",
      },
      {
        name: "LR7-72HVHX10-650M",
        width: 1.134,
        height: 2.382,
        weight: 28.5,
        voc: 53.9,
        isc: 15.29,
        pMax: 650,
        tkVoc: -0.2,
        tkIsc: 0.05,
        tkPmax: -0.26,
        efficiency: 24.1,
        tSTC: 25,
        panelSheet1: "../images/panels/Longi/LR7-72HVHX10-630-650-1.jpg",
        panelSheet2: "../images/panels/Longi/LR7-72HVHX10-630-650-2.jpg",
      },
    ],
  },

  {
    brand: "Neo-Star",
    panelType: [
      {
        name: "AIKO-A655-MAH78Dw",
        width: 1.134,
        height: 2.465,
        weight: 34.7,
        voc: 58.74,
        isc: 14.21,
        pMax: 655,
        tkVoc: -0.22,
        tkIsc: 0.05,
        tkPmax: -0.26,
        efficiency: 23.4,
        tSTC: 25,
        panelSheet1: "../images/panels/NeoStar/A655-680-MAH78Dw-1.jpg",
        panelSheet2: "../images/panels/NeoStar/A655-680-MAH78Dw-2.jpg",
      },
      {
        name: "AIKO-A660-MAH78Dw",
        width: 1.134,
        height: 2.465,
        weight: 34.7,
        voc: 58.8,
        isc: 14.28,
        pMax: 660,
        tkVoc: -0.22,
        tkIsc: 0.05,
        tkPmax: -0.26,
        efficiency: 23.6,
        tSTC: 25,
        panelSheet1: "../images/panels/NeoStar/A655-680-MAH78Dw-1.jpg",
        panelSheet2: "../images/panels/NeoStar/A655-680-MAH78Dw-2.jpg",
      },

      {
        name: "AIKO-A665-MAH78Dw",
        width: 1.134,
        height: 2.465,
        weight: 34.7,
        voc: 58.86,
        isc: 14.35,
        pMax: 665,
        tkVoc: -0.22,
        tkIsc: 0.05,
        tkPmax: -0.26,
        efficiency: 23.8,
        tSTC: 25,
        panelSheet1: "../images/panels/NeoStar/A655-680-MAH78Dw-1.jpg",
        panelSheet2: "../images/panels/NeoStar/A655-680-MAH78Dw-2.jpg",
      },
      {
        name: "AIKO-A670-MAH78Dw",
        width: 1.134,
        height: 2.465,
        weight: 34.7,
        voc: 58.92,
        isc: 14.42,
        pMax: 670,
        tkVoc: -0.22,
        tkIsc: 0.05,
        tkPmax: -0.26,
        efficiency: 24,
        tSTC: 25,
        panelSheet1: "../images/panels/NeoStar/A655-680-MAH78Dw-1.jpg",
        panelSheet2: "../images/panels/NeoStar/A655-680-MAH78Dw-2.jpg",
      },
      {
        name: "AIKO-A675-MAH78Dw",
        width: 1.134,
        height: 2.465,
        weight: 34.7,
        voc: 58.98,
        isc: 14.49,
        pMax: 675,
        tkVoc: -0.22,
        tkIsc: 0.05,
        tkPmax: -0.26,
        efficiency: 24.1,
        tSTC: 25,
        panelSheet1: "../images/panels/NeoStar/A655-680-MAH78Dw-1.jpg",
        panelSheet2: "../images/panels/NeoStar/A655-680-MAH78Dw-2.jpg",
      },
      {
        name: "AIKO-A680-MAH78Dw",
        width: 1.134,
        height: 2.465,
        weight: 34.7,
        voc: 59.04,
        isc: 14.56,
        pMax: 680,
        tkVoc: -0.22,
        tkIsc: 0.05,
        tkPmax: -0.26,
        efficiency: 24.3,
        tSTC: 25,
        panelSheet1: "../images/panels/NeoStar/A655-680-MAH78Dw-1.jpg",
        panelSheet2: "../images/panels/NeoStar/A655-680-MAH78Dw-2.jpg",
      },
    ],
  },

  {
    brand: "Q-Cell",
    panelType: [
      {
        name: "M-G11S 400",
        width: 1.159,
        height: 1.722,
        weight: 21.1,
        voc: 37.06,
        isc: 13.88,
        pMax: 400,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Q-Cell/400-420-1.jpg",
        panelSheet2: "../images/panels/Q-Cell/400-420-2.jpg",
      },
      {
        name: "M-G11S 405",
        width: 1.159,
        height: 1.722,
        weight: 21.1,
        voc: 37.09,
        isc: 13.91,
        pMax: 405,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Q-Cell/400-420-1.jpg",
        panelSheet2: "../images/panels/Q-Cell/400-420-2.jpg",
      },
      {
        name: "M-G11S 410",
        width: 1.159,
        height: 1.722,
        weight: 21.1,
        voc: 37.11,
        isc: 13.95,
        pMax: 410,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.0,
        tSTC: 25,
        panelSheet1: "../images/panels/Q-Cell/400-420-1.jpg",
        panelSheet2: "../images/panels/Q-Cell/400-420-2.jpg",
      },
      {
        name: "M-G11S 415",
        width: 1.159,
        height: 1.722,
        weight: 21.1,
        voc: 37.14,
        isc: 13.99,
        pMax: 415,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Q-Cell/400-420-1.jpg",
        panelSheet2: "../images/panels/Q-Cell/400-420-2.jpg",
      },
      {
        name: "M-G11S 400",
        width: 1.159,
        height: 1.722,
        weight: 21.1,
        voc: 37.17,
        isc: 14.03,
        pMax: 420,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Q-Cell/400-420-1.jpg",
        panelSheet2: "../images/panels/Q-Cell/400-420-2.jpg",
      },
      {
        name: "ML-G11S 495",
        width: 1.159,
        height: 2.092,
        weight: 25.7,
        voc: 45.32,
        isc: 13.91,
        pMax: 495,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Q-Cell/495-515-1.jpg",
        panelSheet2: "../images/panels/Q-Cell/495-515-2.jpg",
      },
      {
        name: "ML-G11S 500",
        width: 1.159,
        height: 2.092,
        weight: 25.7,
        voc: 45.35,
        isc: 13.94,
        pMax: 500,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.1,
        tSTC: 25,
        panelSheet1: "../images/panels/Q-Cell/495-515-1.jpg",
        panelSheet2: "../images/panels/Q-Cell/495-515-2.jpg",
      },
      {
        name: "ML-G11S 505",
        width: 1.159,
        height: 2.092,
        weight: 25.7,
        voc: 45.38,
        isc: 13.97,
        pMax: 505,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Q-Cell/495-515-1.jpg",
        panelSheet2: "../images/panels/Q-Cell/495-515-2.jpg",
      },
      {
        name: "ML-G11S 510",
        width: 1.159,
        height: 2.092,
        weight: 25.7,
        voc: 45.41,
        isc: 14,
        pMax: 510,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Q-Cell/495-515-1.jpg",
        panelSheet2: "../images/panels/Q-Cell/495-515-2.jpg",
      },
      {
        name: "ML-G11S 515",
        width: 1.159,
        height: 2.092,
        weight: 25.7,
        voc: 45.43,
        isc: 14.03,
        pMax: 515,
        tkVoc: -0.27,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Q-Cell/495-515-1.jpg",
        panelSheet2: "../images/panels/Q-Cell/495-515-2.jpg",
      },
    ],
  },

  {
    brand: "Trina",
    panelType: [
      {
        name: "TSM-DE19 530",
        width: 1.096,
        height: 2.384,
        weight: 28.3,
        voc: 37.1,
        isc: 18.31,
        pMax: 530,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/530-555-1.jpg",
        panelSheet2: "../images/panels/Trian/530-555-2.jpg",
      },
      {
        name: "TSM-DE19 535",
        width: 1.096,
        height: 2.384,
        weight: 28.3,
        voc: 37.3,
        isc: 18.36,
        pMax: 535,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/530-555-1.jpg",
        panelSheet2: "../images/panels/Trian/530-555-2.jpg",
      },
      {
        name: "TSM-DE19 540",
        width: 1.096,
        height: 2.384,
        weight: 28.3,
        voc: 37.5,
        isc: 18.41,
        pMax: 540,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/530-555-1.jpg",
        panelSheet2: "../images/panels/Trian/530-555-2.jpg",
      },
      {
        name: "TSM-DE19 545",
        width: 1.096,
        height: 2.384,
        weight: 28.3,
        voc: 37.7,
        isc: 18.47,
        pMax: 545,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/530-555-1.jpg",
        panelSheet2: "../images/panels/Trian/530-555-2.jpg",
      },
      {
        name: "TSM-DE19 550",
        width: 1.096,
        height: 2.384,
        weight: 28.3,
        voc: 37.9,
        isc: 18.52,
        pMax: 550,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/530-555-1.jpg",
        panelSheet2: "../images/panels/Trian/530-555-2.jpg",
      },
      {
        name: "TSM-DE19 555",
        width: 1.096,
        height: 2.384,
        weight: 28.3,
        voc: 38.1,
        isc: 18.56,
        pMax: 555,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.2,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/530-555-1.jpg",
        panelSheet2: "../images/panels/Trian/530-555-2.jpg",
      },
      {
        name: "TSM-DE19 560",
        width: 1.134,
        height: 2.382,
        weight: 28.6,
        voc: 45.3,
        isc: 15.76,
        pMax: 560,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/560-585-1.jpg",
        panelSheet2: "../images/panels/Trian/560-585-2.jpg",
      },
      {
        name: "TSM-DE19 565",
        width: 1.134,
        height: 2.382,
        weight: 28.6,
        voc: 45.6,
        isc: 15.81,
        pMax: 565,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 20.9,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/560-585-1.jpg",
        panelSheet2: "../images/panels/Trian/560-585-2.jpg",
      },
      {
        name: "TSM-DE19 570",
        width: 1.134,
        height: 2.382,
        weight: 28.6,
        voc: 45.8,
        isc: 15.85,
        pMax: 570,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.1,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/560-585-1.jpg",
        panelSheet2: "../images/panels/Trian/560-585-2.jpg",
      },
      {
        name: "TSM-DE19 575",
        width: 1.134,
        height: 2.382,
        weight: 28.6,
        voc: 46.1,
        isc: 15.9,
        pMax: 575,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.3,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/560-585-1.jpg",
        panelSheet2: "../images/panels/Trian/560-585-2.jpg",
      },
      {
        name: "TSM-DE19 580",
        width: 1.134,
        height: 2.382,
        weight: 28.6,
        voc: 46.3,
        isc: 15.94,
        pMax: 580,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.5,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/560-585-1.jpg",
        panelSheet2: "../images/panels/Trian/560-585-2.jpg",
      },
      {
        name: "TSM-DE19 585",
        width: 1.134,
        height: 2.382,
        weight: 28.6,
        voc: 46.6,
        isc: 15.99,
        pMax: 585,
        tkVoc: -0.34,
        tkIsc: 0.04,
        tkPmax: -0.34,
        efficiency: 21.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/560-585-1.jpg",
        panelSheet2: "../images/panels/Trian/560-585-2.jpg",
      },
      {
        name: "TSM-NEG19RC 585",
        width: 1.134,
        height: 2.382,
        weight: 33.7,
        voc: 47.5,
        isc: 15.68,
        pMax: 585,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.29,
        efficiency: 21.7,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/585-610-1.jpg",
        panelSheet2: "../images/panels/Trian/585-610-2.jpg",
      },
      {
        name: "TSM-NEG19RC 590",
        width: 1.134,
        height: 2.382,
        weight: 33.7,
        voc: 47.8,
        isc: 15.72,
        pMax: 590,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.29,
        efficiency: 21.8,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/585-610-1.jpg",
        panelSheet2: "../images/panels/Trian/585-610-2.jpg",
      },
      {
        name: "TSM-NEG19RC 595",
        width: 1.134,
        height: 2.382,
        weight: 33.7,
        voc: 48.1,
        isc: 15.76,
        pMax: 595,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.29,
        efficiency: 22,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/585-610-1.jpg",
        panelSheet2: "../images/panels/Trian/585-610-2.jpg",
      },
      {
        name: "TSM-NEG19RC 600",
        width: 1.134,
        height: 2.382,
        weight: 33.7,
        voc: 48.4,
        isc: 15.8,
        pMax: 600,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.29,
        efficiency: 22.2,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/585-610-1.jpg",
        panelSheet2: "../images/panels/Trian/585-610-2.jpg",
      },
      {
        name: "TSM-NEG19RC 605",
        width: 1.134,
        height: 2.382,
        weight: 33.7,
        voc: 48.7,
        isc: 15.83,
        pMax: 605,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.29,
        efficiency: 22.4,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/585-610-1.jpg",
        panelSheet2: "../images/panels/Trian/585-610-2.jpg",
      },
      {
        name: "TSM-NEG19RC 610",
        width: 1.134,
        height: 2.382,
        weight: 33.7,
        voc: 49,
        isc: 15.86,
        pMax: 610,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.29,
        efficiency: 22.6,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/585-610-1.jpg",
        panelSheet2: "../images/panels/Trian/585-610-2.jpg",
      },
      {
        name: "TSM-XXXNEG20C.20 615",
        width: 1.303,
        height: 2.172,
        weight: 33.7,
        voc: 49,
        isc: 15.86,
        pMax: 615,
        tkVoc: -0.24,
        tkIsc: 0.04,
        tkPmax: -0.29,
        efficiency: 22.6,
        tSTC: 25,
        panelSheet1: "../images/panels/Trian/TSMNEG20C-600-620-1.jpg",
        panelSheet2: "../images/panels/Trian/TSMNEG20C-600-620-2.jpg",
      },
    ],
  },
];
